//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import YoutubeFeed from './YoutubeFeed.vue'

export default {
  data: function() {
    return {
      playlist: pageInfo.youtube_playlist
    };
  },
  components: {
      YoutubeFeed
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/YoutubeTemplate.vue